import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '../../global/global';
import { Car } from '../../models/car.model';

@Injectable({
  providedIn: 'root'
})
export class CarService {

  constructor(
    private httpClient:HttpClient
  ) { }

  getCars(){
    console.log("getting cars obj");
    return this.httpClient.get<Car[]>(Global.BASE_API_URL + "/api/cars")
  }

  public deleteCar(car: Car){
    return this.httpClient.delete<Car> (Global.BASE_API_URL + "/api/cars/" + car.id)
  }

  public createCar(car: Car){
    return this.httpClient.post<Car>(Global.BASE_API_URL + "/api/cars/", car);
  }
  
}
